<template>
    <div class="content-light">
        <div class="header">
            <h3>{{ $t('profile') }}</h3>
        </div>
        <el-card shadow="never">
            <el-form :model="model" status-icon label-width="200px">
                <el-form-item :label="$t('first_name')" prop="name" :error="error_form.name">
                    <el-input v-model="model.name"></el-input>
                </el-form-item>
                <el-form-item :label="$t('avatar')" prop="imageFile" :error="error_form.imageFile">
                    <img src="../assets/cover-blank.png" class="avatar" :style="{backgroundImage: `url('${$store.getters.getUser.avatar || require('../assets/avatar.png')}')`}" />

                    <FileSelect v-model="imageFile" />
                </el-form-item>
                <el-form-item label="E-mail" prop="email" >
                    <el-input v-model="model.email" disabled=""></el-input>
                </el-form-item>
                <el-form-item label="Skype" prop="skype" :error="error_form.skype">
                    <el-input v-model="model.skype"></el-input>
                </el-form-item>
                <el-form-item label="Telegram" prop="telegram" :error="error_form.telegram">
                    <el-input v-model="model.telegram"></el-input>
                </el-form-item>
                <el-form-item :label="$t('phone')" prop="phone" :error="error_form.phone">
                    <el-input v-model="model.phone"></el-input>
                </el-form-item>
                <el-form-item :label="$t('about_me')" prop="about" :error="error_form.about">
                    <el-input v-model="model.about" type="textarea"></el-input>
                </el-form-item>

                <el-form-item :label="$t('time_zone')" prop="timezone_id" :error="error_form.timezone_id">
                    <el-select
                            v-model="model.timezone_id"
                            filterable
                            style="width:100%"
                    >
                        <el-option
                                v-for="item in timezones"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="save" :loading="loading_form">{{ $t('save') }}</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <PaymentWallet />

        <Domain />

        <ChangePassword />

    </div>
</template>

<script>
    import ChangePassword from "../components/ChangePassword";
    import PaymentWallet from "../components/PaymentWallet";
    import Domain from "../components/Domain";
    import FileSelect from "../components/FileSelect";
    export default {
        name: "Profile",
        components: {FileSelect, Domain, PaymentWallet, ChangePassword},
        data () {
            return {
                activeName: 'first',
                model: {},
                loading_form: false,
                error_form: {},
                timezones: [],
                imageFile: null
            };
        },
        created () {
            this.model = Object.assign({}, this.$store.getters.getUser);

            this.$axios.get('/profile/timezones').then((res) => {
                this.timezones = res.data;
            });
        },
        watch: {
            '$store.getters.getUser': {
                handler () {
                    if (!Object.keys(this.model).length) {
                        this.model = Object.assign({}, this.$store.getters.getUser);
                    }
                },
                deep: true
            },
            imageFile () {
                if (this.imageFile) {
                    let formData = new FormData();
                    formData.append("imageFile", this.imageFile);
                    this.error_form = {};
                    let config = {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    };
                    this.$axios.post('/profile/upload', formData, config)
                        .then((res) => {
                            this.$store.commit('setUser', Object.assign(this.$store.getters.getUser, res.data));
                        }).catch((error) => {
                        if (error.response.status  === 422) {
                            this.error_form = error.response.data;
                        }
                    });
                }
            }
        },
        methods: {
            save () {
                this.loading_form = true;
                this.$axios.post('/profile', this.model).then((res) => {
                    this.$store.commit('setUser', Object.assign(this.$store.getters.getUser, res.data));
                    this.$message.success(this.$t('notice.profile_success'));
                    this.error_form = {};
                    this.loading_form = false;
                }).catch((error) => {
                    this.error_form = error.response.data;
                    this.loading_form=false;
                });
            }
        }

    }
</script>

<style lang="scss" scoped>
    .header {
        h3 {
            margin-top: 0;
        }
    }
    .avatar {
        width: 100px;
        height: 100px;
        margin-right: 15px
    }
</style>